import { Commit } from "vuex";
import { http } from "../../plugins/axios";

export interface MaternityState {}

const state = (): MaternityState => ({});

const mutations = {};

const getters = {};

const actions = {
  async createMaternityApplication({ commit }: { commit: Commit }, data: any) {
    const endpoint = "/application/maternity";

    const res = await http.post(endpoint, data);

    return res.data;
  },
  async getMaternityTypes() {
    const endpoint = "/application/maternity/types";

    const res = await http.get(endpoint);

    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
